import { all, call, put, takeLatest, select } from 'redux-saga/effects';
import API from '../../helpers/sagaApi/SagaApi';
import { getBranchId, getJwtToken } from '../sagaAuth/sagaAuthSaga';
import Actions, { SagaUserTypes } from './sagaUserRedux';
import { currentLanguageRfc3066Fnc } from '../languageSwitcher/languageSwitcherSaga';

export function* requestGetAgents(action) {
    const tag = '[REQUEST_GET_AGENTS]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken();
        const branchId = yield getBranchId();
        if (jwtToken) {
            // step 2 : validation passed..
            const response = yield call(API.GetAgents, jwtToken, branchId);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestGetAgents response :`, response.data);
                yield put(Actions.getAgentsSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('NotLoggedIn'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestGetAgents failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.getAgentsFailure(message));
    }
}

export function* requestSelectedDashboard(action) {
    const tag = '[REQUEST_SELECTED_DASHBOARD]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken();
        if (jwtToken) {
            // step 2 : validation passed..
            const response = yield call(API.requestGetUserDashboard, jwtToken, action.userId);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestSelectedDashboard response :`, response.data);
                yield put(Actions.selectedDashboardSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }
        } else {
            throw new Error('xx.yyInvalidInput'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestSelectedDashboard failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.selectedDashboardFailure(message));
    }
}

export function* requestUpdateDashboardLayoutChanged(action) {
    const tag = '[REQUEST_UPDATE_DASHBOARD_LAYOUT_CHANGED]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken();
        if (jwtToken) {
            // step 2 : validation passed..
            const response = yield call(API.requestUpdateDashboardLayoutChanged, jwtToken, action.userId, action.dashboardLayout, action.selectedDashboard);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestUpdateDashboardLayoutChanged response :`, response.data);
                yield put(Actions.updateDashboardLayoutChangedSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }
        } else {
            throw new Error('xx.yyInvalidInput'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestUpdateDashboardLayoutChanged failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.updateDashboardLayoutChangedFailure(message));
    }
}

export function* requestGetuserCalendar(action) {
    const tag = '[REQUEST_GETUSER_CALENDAR]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken();
        const branchId = yield getBranchId();
        const culture = yield select(currentLanguageRfc3066Fnc);
        if (jwtToken) {
            // step 2 : validation passed..
            const response = yield call(API.requestGetuserCalendar, jwtToken, branchId, culture, action.userId, action.selectedMonth, action.selectedYear, action.dataType);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestGetuserCalendar response :`, response.data);
                yield put(Actions.getuserCalendarSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('xx.yyInvalidInput'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestGetuserCalendar failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.getuserCalendarFailure(message));
    }
}

export default function* rootSaga() {
    yield all([
        takeLatest(SagaUserTypes.REQUEST_GET_AGENTS, requestGetAgents),
        takeLatest(SagaUserTypes.REQUEST_SELECTED_DASHBOARD, requestSelectedDashboard),
        takeLatest(SagaUserTypes.REQUEST_UPDATE_DASHBOARD_LAYOUT_CHANGED, requestUpdateDashboardLayoutChanged),
        takeLatest(SagaUserTypes.REQUEST_GETUSER_CALENDAR, requestGetuserCalendar),
    ]);
}



// WEBPACK FOOTER //
// ./src/redux/sagaUser/sagaUserSaga.ts